//* 记录用户访问记录
export default defineNuxtRouteMiddleware(async (to, from) => {
    const website = useWebsiteStore();
    if (to.meta.name == "Home") website.updated({ view: website.agent });
    else {
        website.updated({ view: "default" });
    }
});
